import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";
import "./newtoggle.scss";
export default function NewCustomToggle(props) {
  const { inputProps, labelText, className = "" } = props;

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            {...inputProps}
            classes={{
              root:  "new-custom-switch-root",
              track: "new-custom-switch-track",
              thumb: "new-custom-switch-thumb",
              switchBase: "new-custom-switch-base",
            }}
          />
        }
        label={labelText}
        labelPlacement={"Start"}
        classes={{
          root: className??"new-switch-form-control-label",
        }}
      />
    </div>
  );
}
